import { createSelector } from '@reduxjs/toolkit';

import { isTruthy } from '../utils';
import {
  selectIsElectricianQld,
  selectIsPlumberVic,
  selectIsPropertyOwner,
} from './selectBusinessDetails';
import { selectCoverDetails } from './selectCoverDetails';

export const selectIsValidLiabilityCpi = createSelector(
  [selectCoverDetails, selectIsPlumberVic, selectIsElectricianQld],
  (coverDetails, isPlumberVic, isElectricianQld) =>
    (!isElectricianQld || isTruthy(coverDetails.cpiQLD)) &&
    (!isPlumberVic ||
      (isTruthy(coverDetails.cpiVIC) &&
        (!coverDetails.cpiVIC || (coverDetails.cpiVIC && coverDetails.plumbingLicences?.length))))
);

export const selectIsValidLiability = createSelector(
  [selectCoverDetails, selectIsPropertyOwner, selectIsValidLiabilityCpi],
  (coverDetails, isPropertyOwner, isValidLiabilityCpi) =>
    isTruthy(coverDetails.liabilityLimit) &&
    isValidLiabilityCpi &&
    (isPropertyOwner || isTruthy(coverDetails.useOfContractors))
);
